import Vue, { VNodeDirective } from 'vue'
import MarkdownIt from 'markdown-it'

const markdown = new MarkdownIt({
	breaks: true,
})

interface Bindings extends VNodeDirective {
	value?: string
	oldValue?: string
}

Vue.directive('markdown', (el, { value }: Bindings) => {
	el.innerHTML = value ? markdown.renderInline(value) : ''
})
